var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "draggable",
    _vm._b(
      { staticClass: "table-drag", attrs: { list: _vm.list } },
      "draggable",
      _vm.dragOptions,
      false
    ),
    _vm._l(_vm.list, function (i) {
      return _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isDisabled(i),
              expression: "!isDisabled(i)",
            },
          ],
          key: i.prop,
          staticClass: "column-item",
        },
        [
          _c("i", {
            staticClass: "iconfont iconSort drag-icon icon move",
            attrs: { title: "移动" },
          }),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.isDisabled(i) },
              model: {
                value: i.active,
                callback: function ($$v) {
                  _vm.$set(i, "active", $$v)
                },
                expression: "i.active",
              },
            },
            [_vm._v(_vm._s(_vm.language[i.prop] || i.label))]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }